import {skipToken} from '@reduxjs/toolkit/query';

import {useGetBusinessCaseQuery} from '@dms/api/sales';
import {usePricePermissions} from '@dms/shared';

import type {CustomerInsightsBusinessCaseRecord} from '../types/CustomerInsightsViewModel';
import {canReadCustomerInsightsBusinessCasePrice} from '../utils/canReadCustomerInsightsBusinessCasePrice';
import {getCustomerInsightsBusinessCasePrice} from '../utils/getCustomerInsightsBusinessCasePrice';

export function useCustomerInsightsBusinessCasePrice(
  record: CustomerInsightsBusinessCaseRecord | undefined
) {
  const {canReadBusinessCasePurchaseTotalPrice, canReadBusinessCaseSaleTotalPrice} =
    usePricePermissions({
      businessCaseRecordId: record?.id ?? null,
      vehicleRecordId: null,
    });
  const businessCaseQuery = useGetBusinessCaseQuery(
    record === undefined ? skipToken : {businessCaseId: record.id}
  );
  const {currentData: businessCase} = businessCaseQuery;
  const canReadPrice =
    record === undefined
      ? false
      : canReadCustomerInsightsBusinessCasePrice(businessCase?.businessCaseType ?? record.type, {
          canReadBusinessCasePurchaseTotalPrice,
          canReadBusinessCaseSaleTotalPrice,
        });

  return {
    price: record?.price ?? getCustomerInsightsBusinessCasePrice(businessCase),
    canReadPrice,
    businessCase,
    isLoading: businessCaseQuery.isLoading || businessCaseQuery.isFetching,
    isError: businessCaseQuery.isError,
    retry: businessCaseQuery.refetch,
  };
}
